module.exports = __webpack_public_path__ + "img/green.fab37a0e.svg";